import TrainingCategoryCard from "./TrainingCategoryCard";

export default TrainingCategoryCard;